import { fabric } from "fabric"

export const loadImgAsync = (path) =>
  new Promise((resolve) => {
    var img = new Image()
    img.crossOrigin = "anonymous"
    img.src = path
    img.onload = () => resolve(img)
  })

export const asyncLoadFabricImg = (src, options = {}) =>
  new Promise((resolve) => {
    fabric.util.loadImage(
      src,
      function (url) {
        resolve(new fabric.Image(url))
      },
      null,
      {
        crossOrigin: "anonymous",
      }
    )
    // fabric.Image.fromURL(src, resolve, options)
  })

export const asyncSetOverlayImage = async (ctx, img, opts) =>
  new Promise((resolve) => {
    ctx.setOverlayImage(img, resolve, opts)
  })

export const asyncLoadSVG = (svg) =>
  new Promise((resolve) =>
    fabric.loadSVGFromURL(svg, (objects, options) =>
      resolve({ objects, options })
    )
  )

export const getPathFromSvg = async (svgUrl, options) => {
  const { objects } = await asyncLoadSVG(svgUrl)
  return new fabric.Path(objects[0].d, options)
}

export const initializeSVGPath = async (svgUrl) => {
  const { objects, options } = await asyncLoadSVG(svgUrl)

  return fabric.util.groupSVGElements(objects, options)
}

export const initializeCanvasBackground = (canvas, img, opts) => {
  return new Promise((resolve) => {
    fabric.Image.fromURL(
      img,
      (res) => {
        canvas.setBackgroundImage(res, resolve, opts)
      },
      {
        crossOrigin: "anonymous",
      }
    )
  })
}
